<template>
    <transition name="fade">
        <div
            v-if="visible"
            class="account-not-found-modal-mask"
            @touchmove.prevent
            @click="handleClose"
        >
            <div class="account-not-found-modal-box" @click.stop>
                <div class="modal-body">
                    <div class="modal-title">温馨提示</div>
                    <div class="modal-content">该用户名不存在，是否修改过用户名</div>
                </div>
                <button class="modal-button" type="button" :disabled="processing" @click="handleClose">
                    关闭弹窗并回绑定页
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "RefreshAccountNotFoundModal",
    props: {
        remove: { type: Function, required: true },
        onClose: { type: Function, required: true },
    },
    data() {
        return {
            visible: false,
            processing: false,
        };
    },
    mounted() {
        this.visible = true;
    },
    methods: {
        handleClose() {
            if (this.processing) {
                return;
            }
            this.processing = true;
            Promise.resolve(this.onClose())
                .then(() => {
                    this.visible = false;
                    setTimeout(() => this.remove(), 200);
                })
                .catch(() => {
                    this.processing = false;
                });
        },
    },
};
</script>

<style scoped>
.account-not-found-modal-mask {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.account-not-found-modal-box {
    width: 296px;
    overflow: hidden;
    border-radius: 12px;
    background: #252525;
}

.modal-body {
    min-height: 120px;
    box-sizing: border-box;
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.modal-title,
.modal-content,
.modal-button {
    font-family: "PingFang SC", sans-serif;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
}

.modal-title {
    margin-bottom: 8px;
    color: #d7d7d9;
    font-weight: 500;
}

.modal-content {
    color: #d7d7d9;
    font-weight: normal;
}

.modal-button {
    width: 100%;
    height: 48px;
    padding: 0 12px;
    border: 0;
    border-top: 0.5px solid #323238;
    background: transparent;
    color: #b7a074;
    font-weight: 500;
    cursor: pointer;
}

.modal-button:disabled {
    cursor: default;
    opacity: 0.7;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
